import * as React from 'react';
import { MultiAppAuthenticationError } from '../../styles';
import { I18n, Translate } from 'react-redux-i18n';
import { InputName } from '..';
import { AuthenticateFormInput, AuthenticationInputWrapper } from '../../../Authentication/styles';

interface AuthenticationInputProps {
	value: string;
	errorMessage: string;
	name: InputName;
	onChange: (e: React.FormEvent<HTMLInputElement>, key: InputName) => void;
	autoFocus?: boolean;
}

const getType = (name: InputName) => {
	switch (name) {
		case InputName.Login:
			return 'email';
		case InputName.Password:
			return 'password';
		case InputName.Phone:
			return 'tel';
		default:
			return 'text';
	}
};

const MultiAppAuthenticationInput = ({ value, errorMessage, onChange, name, autoFocus }: AuthenticationInputProps) => {
	return (
		<AuthenticationInputWrapper>
			{errorMessage &&
				<MultiAppAuthenticationError>
					<Translate value={errorMessage} />
				</MultiAppAuthenticationError>
			}
			<AuthenticateFormInput
				value={value}
				onChange={onChange}
				required={true}
				data-error={errorMessage ? errorMessage : undefined}
				type={getType(name)}
				ref={name === InputName.Login
					? (ref) => {
						if (ref) {
							ref.setAttribute('autocorrect', 'none');
							ref.setAttribute('autocapitalize', 'off');
							ref.setAttribute('spellcheck', 'false');
						}
					} : undefined
				}
				minLength={name === InputName.Password ? 6 : undefined}
				placeholder={I18n.t(`messages.placeholder_${name}`)}
				autoFocus={autoFocus}
			/>
		</AuthenticationInputWrapper>
	);
};

export default MultiAppAuthenticationInput;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MultiAppAuthentication/Form/Input/index.tsx